import PreviewComponentLabel from './previewComponentLabel/PreviewComponentLabel';
import HTMLInput from '../../../generic/HTMLEditor/HTMLInput';

const RichText = ({ label, isRequired }: { label: string; isRequired: boolean }) => {
    return (
        <div data-testid="component-preview-richtext" className="component-preview-richtext">
            <PreviewComponentLabel labelText={label} isRequired={isRequired} />
            <HTMLInput contentValue={''} onChange={() => {}} height={300} />
        </div>
    );
};

export default RichText;
